module.exports = __webpack_public_path__ + "static/media/kuibishan_mobile.d7febdd4.webp";